import { ButtonOne } from '../../ButtonOne/ButtonOne.component';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { useStyles } from './CalendarNav.styles';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Month } from '../../../pages/Calendar/Calendar.types';

interface CalendarNavProps {
  year: number;
  monthIndex: number;
  onChange: (direction: 'left' | 'right') => void;
  setCurrentDate: () => void;
}

export const CalendarNav: React.FC<CalendarNavProps> = ({ year, monthIndex, onChange, setCurrentDate }) => {
  const classes = useStyles();

  return (
    <div className={classes.calendarNav}>
      <ButtonOne
        variant="outlined"
        style={{ color: '#3C419A', borderColor: '#3C419A' }}
        startIcon={<EventNoteIcon />}
        onClick={setCurrentDate}
      >
        Aktualny miesiąc
      </ButtonOne>
      <div className={classes.date}>
        {Month[monthIndex]} {year}
      </div>
      <div className={classes.arrows}>
        <KeyboardArrowLeftIcon color="inherit" fontSize="medium" onClick={() => onChange('left')} />
        <KeyboardArrowRightIcon color="inherit" fontSize="medium" onClick={() => onChange('right')} />
      </div>
    </div>
  );
};
